import Vue from 'vue';

Vue.filter('currency', value => {
  var num = new Number(value);
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
});

Vue.filter('cDecimal', (val, digit) => {
  if (!val || val == 'NaN') {
    return '0.00';
  } else if (val == 'Infinity') {
    return '-';
  }
  digit = digit ? Math.pow(10, digit - 1) : 100;
  // return (Math.floor(val * digit) / digit).toFixed(2);
  val = Math.floor(parseFloat((parseFloat(val) * digit).toFixed(2))) / digit;
  val = val.toString();
  if (val.indexOf('.') != -1) {
    var temp = val.split('.')[1];
    if (temp.length < 2) {
      temp = temp + '0';
    }
    val = val.split('.')[0] + '.' + temp;
  } else {
    val = val + '.00';
  }
  return val;
});

Vue.filter('capitalize', str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
});

Vue.filter('comma', value => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});
